import { z } from "zod";

import { AilmentSchema, LateralLocationSchema, LocationSchema } from "api/schemas/shared/Treatment";

const GetPatientArgsSchema = z.object({
  patientID: z.number(),
  treatment_id: z.number().nullable().optional(),
});
export type GetPatientArgs = z.infer<typeof GetPatientArgsSchema>;

export const PatientSchema = z.object({
  address: z.string().nullable(),
  address_state: z
    .object({
      code: z.string(),
      name: z.string(),
    })
    .nullable(),
  adherence: z.number(),
  appointment_to_schedule: z.unknown().nullable(),
  avatars: z.object({
    large: z.string().nullable(),
    medium: z.string().nullable(),
    small: z.string().nullable(),
  }),
  awaiting_treatment_ready: z.boolean(),
  billable_care_events: z
    .object({
      count: z.number(),
      max: z.number(),
    })
    .nullable(),
  birthday: z.string().nullable(),
  ce_structure: z.string(),
  city: z.string().nullable(),
  clinic: z.unknown().nullable(),
  co_payer: z.boolean(),
  country: z.string(),
  current_course_strategy: z.string().nullable(),
  deleted_at: z.string().nullable(),
  email: z.string(),
  end_treatment_at: z.string().nullable(),
  feature_flags: z.array(z.string()),
  first_day_activities_enabled: z.boolean(),
  first_name: z.string(),
  gender: z.enum(["female", "male"]).nullable(),
  goal: z.string(),
  iana_timezone: z.string(),
  id: z.number(),
  joined_at: z.string(),
  last_activity_at: z.string().nullable(),
  last_medical_referral_signature_at: z.string().nullable(),
  last_name: z.string(),
  last_received_message_at: z.string().nullable(),
  new_comments: z.boolean(),
  new_messages: z.boolean(),
  new_patient: z.boolean(),
  npo_consent: z.boolean().nullable(),
  out_of_pocket_state: z.string().nullable(),
  payer: z.object({
    payer_type: z.string(),
  }),
  payer_category: z.string(),
  payer_name: z.string(),
  payment_method: z.string(),
  personal_number: z.string().nullable(),
  phone_number: z.string(),
  physio_viewed_at: z.string().nullable(),
  preferred_name: z.string(),
  premium_activation_state: z.string(),
  premium_type: z.string(),
  prio: z.boolean(),
  pt_on_demand_enabled: z.boolean(),
  ready_for_discharge: z.boolean(),
  referral_process_status: z.string().nullable(),
  registered_in_region: z.boolean(),
  review: z.boolean(),
  saas_payer: z.boolean(),
  schedule_version: z.number(),
  state: z.string(),
  status: z.string(),
  therapist_assignment_role: z.enum(["main_therapist", "substitute_therapist"]).nullable(),
  treatment_length: z.number().nullable(),
  treatment_started: z.boolean(),
  treatments: z.array(
    z.object({
      ailment: AilmentSchema,
      created_at: z.string(),
      id: z.number(),
      is_current_treatment: z.boolean(),
      lateral_location: LateralLocationSchema.nullable(),
      pain_location: LocationSchema.nullable(),
    })
  ),
  uid: z.string(),
  week: z.number(),
  zip_code: z.string().nullable(),
});
export type Patient = z.infer<typeof PatientSchema>;
